import React, {useState} from 'react';
import styles from './card-slider.module.scss'
import { UPLOADHOST } from "../../constants/constants";
const CardSlider = ({ data, direction }) => {
  const [active, setActive] = useState([0, 'active']);
  const onClick = (index) => {
    setActive([index, 'active']);
  }

  return (
    <div className={`${styles.wrapper} ${styles[direction]}`}>
      {data.slice(0, 2).map((item, index) => (
        <div
          key={item + index}
          className={`${styles.card} ${active[0] === index ? styles.active : styles.notActive}`}
          onClick={() => onClick(index)}
        >
          <img src={`${UPLOADHOST}${item.url}`} alt={`card_${item.id}`} />
        </div>
      ))}
    </div>
  );
};

export default CardSlider;